import { Outlet } from 'react-router-dom';

/**
 * SalesLayout - Minimal layout for sales staff mobile interface
 *
 * Unlike AdminLayout, sales pages manage their own headers since
 * each page has different navigation needs (back buttons, etc.)
 *
 * This layout just provides a wrapper for the sales staff pages.
 */
export default function SalesLayout() {
  return <Outlet />;
}
